module.exports = (value, toCompare) => value !== toCompare
